import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LikesService } from 'src/app/shared/likes.service';
import WaveSurfer from 'wavesurfer.js';
import { DashboardService } from '../my-dashboard.service';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-mobile-podcast',
  templateUrl: './mobile-podcast.component.html',
  styleUrls: ['./mobile-podcast.component.scss']
})
export class MobilePodcastComponent implements OnInit {
  isPodcastSlideOpen:boolean=false;
	isDoseDetailsOpen:boolean=false;
	isMoreDetailsOpen:boolean=false;
	isCommentBoxOpen:boolean=false;
	isLiked:boolean=false;
	isComment:boolean=false;

  @ViewChild('mobilewaveform') private waveformElement?: ElementRef<HTMLDivElement>;
	wavesurfer?: WaveSurfer;
	audioUrls: string[] = [
		// '../../../../../assets/sample-3s.mp3'
		"../../../../../../assets/orchestrawav-26158.mp3"
	];
	urlIndex: number = 0;
	isPlaying: boolean = false;
	currentTime: any = 0;
	durationTime: number = 0;
	skipForward:any = 0;
	skipBackward:any = 0;
	prgNameHeight:number=0;
	podcasts: any;
	selectedPodcast: any;
	selectedPodcastSeason: any;
	selectedPodcastEpisode: any;
	likesIdData: any;
	likeDocId: any;
	commentBoxText: string = "";
	userId: string = "";
	commentsIdData: any;
	commentDocId: any;
	blockLoader: string = "blockLoader";
	selectPodcastIndex:any;
	userData: any;
	isMuted:boolean=false;
	isiPhone:boolean=false;
	currentPipValue: any;
	isLoadingWavesurfer: boolean = false;
	customWaveSurfer: any[] = [];
	wavesProgress: any = [];

  constructor(
	@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private likesService: LikesService,
	private _bottomSheetRef: MatBottomSheetRef<MobilePodcastComponent>,
	private snackbar: MatSnackBar,
	private dashboardService: DashboardService,
	private spinner: NgxSpinnerService,
	private deviceDetectorService: DeviceDetectorService,
	private elRef: ElementRef
	) {
    // console.log(data.isOpen);
	_bottomSheetRef.backdropClick().subscribe((res:any)=>{
		this.likesService.setPIPValue('close')
	});

	this.likesService.getPIPValue().subscribe(async value => {
		this.currentPipValue = value;

		if (this.currentPipValue === 'maximize') {
			const currTime = this.likesService.currentTimeValue.getValue();
			this.wavesurfer?.setTime(currTime);

			// setTimeout(() => {
			// 	let playingState: any = localStorage.getItem('playingStateMax');
			// 	// console.log(playingState);
			// 	if (playingState === "true") {
			// 		playingState = true;
			// 	} else {
			// 		playingState = false;
			// 	}
			// 	if (this.wavesurfer && playingState) {
			// 		console.log("played cause of this!")
			// 		this.wavesurfer.play();
			// 	}
			// }, 100);
		}
	});
  }

  	async ngOnInit() {
		// console.log(this.data);
		this.isiPhone = this.deviceDetectorService.isMobile() && this.deviceDetectorService.device === 'iPhone';
		this.podcasts = this.data.podcasts;
		this.likesIdData = this.data.likesData;
		this.commentsIdData = this.data.commentsData;
		this.audioUrls = this.data.audioUrls;
		this.userData = this.data.userData;
		this.userId = this.data.userId;
		// console.log(this.podcasts);
	}

	async ngAfterViewInit() {
		if (this.podcasts && this.podcasts.length >= 2) {
			const podcastObservable = this.likesService.selectedPodcastValue.getValue();
			if(podcastObservable && Object.keys(podcastObservable).length >= 1) {
				this.likesService.selectedPodcastValue.next(podcastObservable);
				this.selectedPodcast = podcastObservable;
			}else {
				this.selectedPodcast = this.podcasts[1];
				this.likesService.selectedPodcastValue.next(this.selectedPodcast);
			}

			this.selectPodcastIndex = this.podcasts.findIndex((podcast:any) => {
				return this.selectedPodcast.id === podcast.id;
			})

			this.selectedPodcastSeason = this.selectedPodcast.season_number;
			this.selectedPodcastEpisode = this.selectedPodcast.episode_number;
			let likeDocId;
			const getEpisodeLike = this.likesIdData.findIndex((likeData: any) => {
				let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
				likeDocId = likeData.id;
				return likeData.entityId === entityId;
			});

			if (getEpisodeLike === -1) {
				this.isLiked = false;
				this.likeDocId = "";
			} else {
				this.isLiked = true;
				this.likeDocId = likeDocId;
			}

			let commentDocId;
			let commentText:any;
			const getEpisodeComment = this.commentsIdData.findIndex((commentData: any) => {
				let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
				commentDocId = commentData.id;
				commentText = commentData.text;
				return commentData.entityId === entityId;
			});

			if (getEpisodeComment === -1) {
				this.isComment = false;
				this.commentDocId = "";
				this.commentBoxText = "";
			} else {
				this.isComment = true;
				this.commentDocId = commentDocId;
				this.commentBoxText = commentText;
				this.commentCharacterCount = commentText.length;
			}
		}
		// console.log(this.podcasts);

		if (this.waveformElement) {
			this.wavesurfer = WaveSurfer.create({
				container: this.waveformElement.nativeElement,
				height: 40,
				barWidth: 3,
				barGap: 3,
				waveColor: '#fff',
				progressColor: '#7881E6',
				fetchParams: {
					mode: "no-cors",
				}
			});

			try {
				this.isLoadingWavesurfer = true;
				await this.wavesurfer?.load(this.audioUrls[this.urlIndex]);
			} catch (err) {
				console.log("Error in initial loading of podcast audio.");
			} finally {
				this.isLoadingWavesurfer = false;
			}
			this.durationTime = this.selectedPodcast.duration;
			this.urlIndex = this.selectPodcastIndex - 1;
			this.onUrlChange(this.urlIndex, false);
		}

		this.adjustWaveSurferOptions();
		this.adjustCustomWaveSurferBarsLength();
		setTimeout(() => {
			this.setWavesProgress();
		}, 1000);
		// this.createAllWaveSurfers();
		await this.watchPlayEvent();
	}

	adjustCustomWaveSurferBarsLength() {
		const barWidth = 4;

		const container = this.elRef.nativeElement.querySelector('.more-dose-bars');

		const containerWidth = container.offsetWidth;
		// console.log('container2', container.offsetWidth)

		const maxNumberOfBars = Math.floor(containerWidth / barWidth);

		this.customWaveSurfer.length = maxNumberOfBars;

		for (let i = 0; i < maxNumberOfBars; i++) {
		this.customWaveSurfer[i] = "";
		}

		// console.log('customWaveSurfer', this.customWaveSurfer, maxNumberOfBars)
	}

	async watchPlayEvent() {
		if (this.isPlaying) {
			let currentTime: any = this.wavesurfer?.getCurrentTime();
			if (currentTime) {
				currentTime = Math.ceil(currentTime);
				if (currentTime > this.selectedPodcast.duration || this.selectedPodcast.duration - currentTime <= 2) {
					currentTime = this.selectedPodcast.duration;
				}
				let progress = Math.ceil((currentTime * 100) / this.selectedPodcast.duration);
				if (progress >= 99 || isNaN(progress)) {
					progress = 100;
					currentTime = this.selectedPodcast.duration;
				}

				let entityId = `${this.selectedPodcast.season_number}_${this.selectedPodcast.episode_number}`;
				let podcastsProgress = this.userData.podcastsProgress;

				let newProgressObj: any = {
					watchedDuration: currentTime,
					totalDuration: this.selectedPodcast.duration,
					entityId,
					progress
				};

				if (progress === 100) {
					newProgressObj.completedAt = new Date();
				}
				if (this.userData && podcastsProgress && podcastsProgress.length >= 1) {
					let hasProgressIndex = podcastsProgress.findIndex((item: any) => item.entityId === entityId);
					if (hasProgressIndex === -1) {
						podcastsProgress.push(newProgressObj);
						await this.dashboardService.updateUserData(this.userId, {
							podcastsProgress
						});
					} else {
						let item = podcastsProgress[hasProgressIndex];

						if (item.progress !== 100) {
							podcastsProgress[hasProgressIndex] = newProgressObj;

							await this.dashboardService.updateUserData(this.userId, {
								podcastsProgress
							});
						}
					}
				} else {
					podcastsProgress = [newProgressObj];
					this.userData.podcastsProgress = podcastsProgress;
					await this.dashboardService.updateUserData(this.userId, {
						podcastsProgress
					});
				}
			}
		}

		setTimeout(async () => {
			await this.watchPlayEvent();
		}, 3000);
	}

	adjustWaveSurferOptions () {
		if(window.innerWidth > 500 && window.innerWidth < 700){
			this.wavesurfer?.setOptions({
				height: 30,
				barWidth: 2,
				barGap: 2,
			})
		}else if(window.innerWidth > 700 && window.innerWidth < 900) {
			this.wavesurfer?.setOptions({
				height: 20,
				barWidth: 2,
				barGap: 2,
			})
		}else if (window.innerWidth > 1050 && window.innerWidth < 1250) {
			this.wavesurfer?.setOptions({
				height: 20,
				barWidth: 2,
				barGap: 2,
			})
		} else {
			this.wavesurfer?.setOptions({
				height: 40,
				barWidth: 3,
				barGap: 3,
			})
		}
	}

	createAllWaveSurfers() {
		for (let i = 0; i < this.podcasts.length; i += 1) {
			let waveformElement: any = document.getElementById("waveform" + i);
			// console.log(waveformElement);

			if (waveformElement) {
				const wavesurfer = WaveSurfer.create({
					container: waveformElement,
					height: 20,
					barWidth: 3,
					barGap: 3,
					waveColor: '#E5E5E5',
					progressColor: '#000',
					interact: false,
					cursorColor: '#fff',
					fetchParams: {
						mode: "no-cors",
					}
				});

				wavesurfer.setVolume(0);

				try {
					// await wavesurfer.load(this.audioUrls[0]);
					wavesurfer.load(this.audioUrls[i + 1]).then(() => {});
				} catch (err) {
					console.log("Unload to load other audios.")
				}
			}
		}
	}

	sortByEpisodeNumber() {
		this.podcasts.sort((podcastA: any, podcastB: any) => {
			if (podcastA.episode_number < podcastB.episode_number) {
				return -1;
			} else {
				return 1;
			}
		})
	}

  closePodcastBottomSheet() {
	this._bottomSheetRef.dismiss()
	}

	toggleDoseDetails() {
		this.isDoseDetailsOpen = !this.isDoseDetailsOpen;
		if(this.isMoreDetailsOpen) this.isMoreDetailsOpen = false;
		if(this.isCommentBoxOpen) this.isCommentBoxOpen = false;
	}

	toggleMoreDetails() {
		this.isMoreDetailsOpen = !this.isMoreDetailsOpen;
		if(this.isDoseDetailsOpen) this.isDoseDetailsOpen = false;
		if(this.isCommentBoxOpen) this.isCommentBoxOpen = false;
	}
	toggleCommentBox() {
		this.isCommentBoxOpen = !this.isCommentBoxOpen;
		if(this.isDoseDetailsOpen) this.isDoseDetailsOpen = false;
		if(this.isMoreDetailsOpen) this.isMoreDetailsOpen = false;
	}

	async toggleIsLiked() {
		this.isLiked = !this.isLiked;
		const entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;

		const data = {
			entityType: "podcast",
			userId: this.userId,
			userName: "",
			emotionType: "like",
			entityId,
			createdAt: new Date()
		};

		if (this.isLiked) {
			this.likeDocId = await this.likesService.addLike(data, "");
		} else {
			await this.likesService.removeLike(this.likeDocId);
			this.likeDocId = "";
		}
	}

	skipBackwardFn() {
		this.checkIfAudioIsLoading();

		if (this.wavesurfer) {
			const currentTime = this.wavesurfer.getCurrentTime();
			const newTime = Math.max(0, currentTime - 10);
			this.wavesurfer.seekTo(newTime / this.durationTime);
		}
	}

	skipForwardFn() {
		this.checkIfAudioIsLoading();

		if (this.wavesurfer) {
			const currentTime = this.wavesurfer.getCurrentTime();
			const newTime = Math.min(this.durationTime, currentTime + 10);
			this.wavesurfer.seekTo(newTime / this.durationTime);
		}
	}

	toggleMute() {
		this.checkIfAudioIsLoading();

		if (this.wavesurfer) {
			this.isMuted = !this.isMuted; // Toggle the mute state

			if (this.isMuted) {
				this.wavesurfer.setMuted(true);
			} else {
				this.wavesurfer.setMuted(false);
			}
		}
	}

	changeVolume(volume: number) {
		const normalizedVolume = volume / 100;
		if (this.wavesurfer) {
			this.wavesurfer.setVolume(normalizedVolume);
		}
	}

	async onUrlChange(index: number, shouldPlay: boolean) {
		if (shouldPlay) {
			await this.spinner.show("blockLoader");
			index += 1;
			// console.log(index);

			this.urlIndex = index;

			if (this.wavesurfer) {
				try {
					this.isLoadingWavesurfer = true;
					await this.wavesurfer.load(this.audioUrls[this.urlIndex]);
				} catch (err) {
					console.log("urlChange-if: Unable to load podcast change audio.");
				} finally {
					this.isLoadingWavesurfer = false;
				}

				this.wavesurfer?.on('play', async () => {
					this.isPlaying = true;
					this.likesService.playValueSubject.next(this.isPlaying);
				// console.log("played mp audio - 2!");

				});
				this.wavesurfer?.on('pause', () => {
					this.isPlaying = false;
					this.likesService.playValueSubject.next(this.isPlaying);
				// console.log("paused mp audio - 2!");
				});
				this.wavesurfer?.on('interaction', () => this.skipForwardFn());
				this.wavesurfer?.on('interaction', () => this.skipBackwardFn());
				// this.wavesurfer?.on('ready', () => this.durationTime = this.wavesurfer?.getDuration());
				this.wavesurfer?.on('audioprocess', () => {
					const currentTime = this.wavesurfer?.getCurrentTime();
					this.currentTime = currentTime;

					if (currentTime !== undefined) {
						this.likesService.currentTimeValue.next(currentTime);
						let progress = Number(Number((currentTime * 100 / this.durationTime) / 100).toFixed(2));
						let entityId = `${this.selectedPodcast.season_number}_${this.selectedPodcast.episode_number}`;
						let index = this.podcasts.findIndex((p: any) => {
							let podcastId = `${p.season_number}_${p.episode_number}`;
							return podcastId === entityId;
						});
						this.wavesProgress[index] = progress;
					}
				});
				this.wavesurfer?.on('seeking', () => {
					this.currentTime = this.wavesurfer!.getCurrentTime();
				});
				this.selectedPodcast = this.podcasts[index];
				this.likesService.selectedPodcastValue.next(this.selectedPodcast);
				// console.log(this.selectedPodcast);
				this.selectedPodcastSeason = this.selectedPodcast.season_number;
				this.selectedPodcastEpisode = this.selectedPodcast.episode_number;
				let likeDocId;
				const getEpisodeLike = this.likesIdData.findIndex((likeData: any) => {
					let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
					likeDocId = likeData.id;
					return likeData.entityId === entityId;
				});

				if (getEpisodeLike === -1) {
					this.isLiked = false;
					this.likeDocId = "";
				} else {
					this.isLiked = true;
					this.likeDocId = likeDocId;
				}


				let commentDocId;
				let commentText:any;
				const getEpisodeComment = this.commentsIdData.findIndex((commentData: any) => {
					let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
					commentDocId = commentData.id;
					commentText = commentData.text;
					return commentData.entityId === entityId;
				});

				if (getEpisodeComment === -1) {
					this.isComment = false;
					this.commentDocId = "";
					this.commentBoxText = "";
				} else {
					this.isComment = true;
					this.commentDocId = commentDocId;
					this.commentBoxText = commentText;
					this.commentCharacterCount = commentText.length;
				}

				this.durationTime = this.selectedPodcast.duration;
				if (this.wavesProgress[index] === 0 || this.wavesProgress[index] === 1) {
					this.currentTime = 0;
					console.log("if at line 523");
				} else {
					let progressPercentage = this.wavesProgress[index] * 100;
					this.currentTime = (progressPercentage * this.durationTime) / 100;
					this.wavesurfer.setTime(this.currentTime);
					console.log("else at line 528");
				}
				if (shouldPlay) {
					this.wavesurfer.play();
				}
			}
			await this.spinner.hide("blockLoader");
		} else {
			index += 1;
			// console.log(index);

			this.urlIndex = index;

			setTimeout(async () => {

				let playingState: any = localStorage.getItem('playingStateMax');
				// console.log(playingState);
				if (playingState === "true") {
					playingState = true;
				} else {
					playingState = false;
				}

				if (this.wavesurfer) {
					try {
						this.isLoadingWavesurfer = true;
						await this.wavesurfer.load(this.audioUrls[this.urlIndex]);
					} catch (err) {
						console.log("urlChange-else: Unable to load podcast change audio.");
					} finally {
						this.isLoadingWavesurfer = false;
					}

					this.wavesurfer?.on('play', async () => {
						this.isPlaying = true;
						this.likesService.playValueSubject.next(this.isPlaying);
						// console.log("played mp audio - 3!");
					});
					this.wavesurfer?.on('pause', () => {
						this.isPlaying = false;
						this.likesService.playValueSubject.next(this.isPlaying);
					});
					this.wavesurfer?.on('interaction', () => this.skipForwardFn());
					this.wavesurfer?.on('interaction', () => this.skipBackwardFn());
					// this.wavesurfer?.on('ready', () => this.durationTime = this.wavesurfer?.getDuration());
					this.wavesurfer?.on('audioprocess', () => {
						const currentTime = this.wavesurfer?.getCurrentTime();
						this.currentTime = currentTime;

						if (currentTime !== undefined) {
							this.likesService.currentTimeValue.next(currentTime);
							let progress = Number(Number((currentTime * 100 / this.durationTime) / 100).toFixed(2));
							let entityId = `${this.selectedPodcast.season_number}_${this.selectedPodcast.episode_number}`;
							let index = this.podcasts.findIndex((p: any) => {
								let podcastId = `${p.season_number}_${p.episode_number}`;
								return podcastId === entityId;
							});
							this.wavesProgress[index] = progress;
						}
					});
					this.wavesurfer?.on('seeking', () => {
						this.currentTime = this.wavesurfer!.getCurrentTime();
					});
					this.currentTime = this.likesService.currentTimeValue.getValue();
					if(this.currentTime) {
						this.wavesurfer.setTime(this.currentTime)
					}
					// console.log('currentTime2', this.currentTime)
					this.selectedPodcast = this.podcasts[index];
					this.likesService.selectedPodcastValue.next(this.selectedPodcast);
					// console.log(this.selectedPodcast);
					this.selectedPodcastSeason = this.selectedPodcast.season_number;
					this.selectedPodcastEpisode = this.selectedPodcast.episode_number;
					let likeDocId;
					const getEpisodeLike = this.likesIdData.findIndex((likeData: any) => {
						let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
						likeDocId = likeData.id;
						return likeData.entityId === entityId;
					});

					if (getEpisodeLike === -1) {
						this.isLiked = false;
						this.likeDocId = "";
					} else {
						this.isLiked = true;
						this.likeDocId = likeDocId;
					}

					let commentDocId;
					let commentText:any;
					const getEpisodeComment = this.commentsIdData.findIndex((commentData: any) => {
						let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
						commentDocId = commentData.id;
						commentText = commentData.text;
						return commentData.entityId === entityId;
					});

					if (getEpisodeComment === -1) {
						this.isComment = false;
						this.commentDocId = "";
						this.commentBoxText = "";
					} else {
						this.isComment = true;
						this.commentDocId = commentDocId;
						this.commentBoxText = commentText;
						this.commentCharacterCount = commentText.length;
					}

					this.currentTime = 0;
					this.durationTime = this.selectedPodcast.duration;

					if (this.likesService.playValueSubject.getValue() || playingState) {
						console.log("if at line 640");
						this.wavesurfer.play();
					}
				}
			}, 100);
		}
	}

	setWavesProgress() {
		for (let i = 1; i < this.podcasts.length; i += 1) {
			let podcast = this.podcasts[i];
			let entityId = `${podcast.season_number}_${podcast.episode_number}`;
			let progress = 0;

			// console.log(this.userData);
			if (this.userData && this.userData.podcastsProgress && this.userData.podcastsProgress.length >= 1) {
				for (let userProgressPodcast of this.userData.podcastsProgress) {
					if (userProgressPodcast.entityId === entityId) {
						progress = userProgressPodcast.progress;
						// console.log('prog to ', progress);
						break;
					}
				}
			}

			this.wavesProgress[i] = Number(Number(progress / 100).toFixed(2));
		}

		// console.log(this.wavesProgress);
	}

	onPlayPause(): void {
		if (!this.isLoadingWavesurfer) {
			if (this.wavesurfer) {
				if (this.isPlaying) {
					this.wavesurfer.pause();
				} else {
					this.wavesurfer.play();
				}
			}
		} else {
			this.snackbar.open("Loading podcast audio...", "OK", {
				duration: 3000
			});
		}
	}

	formatTime(seconds: number): string {
		if (isNaN(seconds)) {
			return "Loading...";
		}
		const minutes = Math.floor(seconds / 60);
		const remainderSeconds = Math.floor(seconds % 60);
		return `${('0' + minutes).slice(-2)}:${('0' + remainderSeconds).slice(-2)}`;
	}

    commentCharacterCount: number = 0;

    onInputChange(event: any) {
        this.commentCharacterCount = event.target.value.length;
    }

	setPIPValue(value:any) {
		this.checkIfAudioIsLoading();

		this.wavesurfer?.pause();
		if(value === 'minimize') {
			this.likesService.currentTimeValue.next(this.wavesurfer?.getCurrentTime());
			localStorage.setItem("playingState", String(this.isPlaying));
			setTimeout(() => {
				localStorage.removeItem("playingState");
			}, 10000);
		}
		this.likesService.setPIPValue(value);
		this.closePodcastBottomSheet();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event:any) {
		if(window.innerWidth > 500) {
			this.closePodcastBottomSheet();
		}
		this.adjustCustomWaveSurferBarsLength();
	}

	async saveComment() {
		let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
		await this.likesService.saveComment(this.commentBoxText, entityId, this.userId);
		// this.commentBoxText = "";
		// this.commentCharacterCount = 0;

		this.snackbar.open("Comment saved.", "OK", {
			duration: 3000
		});
	}

	checkIfAudioIsLoading() {
		if (this.isLoadingWavesurfer) {
			this.snackbar.open("Please wait while the audio loads...", "OK", {
				duration: 2000
			});
			return;
		}
	}
}
